import { render, staticRenderFns } from "./IconYearOfService.vue?vue&type=template&id=31ee387a"
import script from "./IconYearOfService.vue?vue&type=script&lang=js"
export * from "./IconYearOfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports